export interface TabComponentProps {
  tabMenuList: tabMenu[];
  isDetailPage?: boolean; // 디테일페이지인지 생성인지 구분
  data?: any;
  setData?: any;
  onChangeInput?: any;
  currentPage?: any;
  setCurrentPage?: any;
  maxIndex?: any;
  setMaxIndex?: any;
}

export interface tabMenu {
  id: number;
  title: string;
}

export interface InputComponentProps {
  label?: string; // 인풋박스 위의 라벨
  width?: string; // 인풋박스의 넓이
  height?: string; // 인풋박스의 높이
  value?: string; // 인풋 값
  name?: string; // value의 경로를 파악하기위한 변수
  isRequired?: boolean; // 필수값 여부
  isTextArea?: boolean; // true이면 인풋이 아닌 textArea로 변경
  outline?: boolean; // 컴포넌트 테두리 영역 보이게
  readOnly?: boolean; // readOnly 여부
  placeholder?: string;
  $borderRadius?: string;
  $backgroundColor?: string;
  $fontSize?: string;
  $fontWeight?: string;
  $color?: string;
  $labelSize?: string;
  $labelFontWeight?: string;
  $labelColor?: string;
  onChangeInput?: any;
}

export interface ListItem {
  id: number;
  name: string;
  spec: string;
  unit: string;
  quantity: string;
  unitPrice: string;
  amount: string;
  remarks: string;
}

export interface ContractList {
  id?: number;
  companyName?: string;
  contactPerson?: string;
  contactNumber?: string;
  receivedDate?: string;
  quotation?: string;
  status?: string;
}

interface CostCategory {
  title: string;
  List: ListItem[];
}

// 새로운 공간을 추가하는(room객체) 함수

export function addNewRoomData(
  lastId: number,
  type: number,
  typeName: string,
  name: string
) {
  let result = {
    id: lastId + 1, // 이전 아이디에서 1 증가
    name: name,
    type: type,
    typeName: typeName,
    quantity: 0,
    cbm: 0,
    itemList: [
      // TODO : 디폴트 아이템 정해지면 추가 예정
      // {
      //   id: 1,
      //   itemCode: "desk1",
      //   category: "책상",
      //   item: "접이식 책상",
      //   quantity: 0,
      //   cbm: 0,
      //   carryType: 0,
      //   isCustom: false,
      // },
    ],
  };

  return result;
}

// 새로운 chargeData 객체를 생성하는 함수
export function createNewChargeData(lastId: number, pageIndex: number) {
  return {
    id: lastId + 1, // 이전 아이디에서 1 증가
    text: `${pageIndex}page`, // 페이지 인덱스에 따라 텍스트 설정
    roomList: [
      {
        id: 1,
        name: "사무실",
        type: 1,
        typeName: "office",
        quantity: 0,
        cbm: 0,
        itemList: [
          // TODO : 디폴트 아이템 정해지면 추가 예정
          // {
          //   id: 1,
          //   itemCode: "desk1",
          //   category: "책상",
          //   item: "접이식 책상",
          //   quantity: 0,
          //   cbm: 0,
          //   carryType: 0,
          //   isCustom: false,
          // },
        ],
      },
    ],
    name: "", // 품명
    category: "", // 작업구분
    contents: "", // 작업내용
    unit: "", // 단위
    remark: "", // 비고
    total: "", // 5. 합계[1+2+3+4]
    expenses: "", // 6.공과잡비
    commonCost: "", // 7.일반관리비
    profit: "", // 8.이윤
    totalServiceCost: "", // 9.총 용역원가
    quotedPrice: "", // 10. 견적가
    expensesRate: "5", // 공과잡비비율
    commonCostRate: "10", // 일반관리비비율
    profitRate: "10", //이윤 비율
    materialCost: {
      title: "재료비",
      total: "0",
      List: [
        {
          id: 0,
          name: "포장용 박스",
          spec: "450*430*400",
          unit: "장",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 1,
          name: "에어캡",
          spec: "50cm*50m",
          unit: "개",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 2,
          name: "포장용 테이프",
          spec: "50mm*50m",
          unit: "개",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 3,
          name: "PC 박스",
          spec: "600*410*470",
          unit: "장",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 4,
          name: "바구니",
          spec: "610*380*320",
          unit: "개",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 5,
          name: "청랩",
          spec: "50cm*500m",
          unit: "롤",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 6,
          name: "물품표",
          spec: "",
          unit: "개",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 7,
          name: "보양자재",
          spec: "",
          unit: "장",
          quantity: "0",
          unitPrice: "0",
          amount: "",
          remarks: "",
        },
        {
          id: 8,
          name: "",
          spec: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          amount: "",
          remarks: "",
        },
        {
          id: 9,
          name: "",
          spec: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          amount: "",
          remarks: "",
        },
      ],
    },
    movingCost: {
      title: "차량비",
      total: "0",
      List: Array(5)
        .fill({
          id: 0,
          name: "",
          spec: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          amount: "",
          remarks: "",
        })
        .map((item, index) => ({ ...item, id: index })),
    },
    laborCost: {
      title: "노무비",
      total: "0",
      List: Array(5)
        .fill({
          id: 0,
          name: "",
          spec: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          amount: "",
          remarks: "",
        })
        .map((item, index) => ({ ...item, id: index })),
    },
    ectCost: {
      title: "기타",
      total: "0",
      List: Array(5)
        .fill({
          id: 0,
          name: "",
          spec: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          amount: "",
          remarks: "",
        })
        .map((item, index) => ({ ...item, id: index })),
    },
  };
}

export function toNumber(formattedNumber: string) {
  // 쉼표(,)와 공백( )을 제거하여 문자열을 숫자로 변환
  return Number(formattedNumber.replace(/[,\s]/g, ""));
}

export function filterDigitsAndHyphen(inputValue: string) {
  // 숫자와 '-' 기호만 남기고 모든 문자를 제거
  return inputValue.replace(/[^\d-]/g, "");
}

export const companyInitialData = {
  contractInfo: {
    clientInfo: {
      // 고객사측 정보
      companyName: "",
      contactPerson: "",
      contactNumber: "",
      email: "",
    },
    headInfo: {
      // 본사측 정보
      companyName: "(주)통인익스프레스",
      contactPerson: "",
      contactNumber: "",
      email: "",
    },
    detailInfo: {
      title: "", // 제목
      totalEmployees: "", // 직원수
      workDate1: "", // 작업일정2
      workDate2: "", // 작업일정1
      contractDate: "", // 계약날짜
      subCondition: "", // 부대조건
      departureAddress1: "", // 출발주소1
      destinationAddress1: "", // 도착주소1
      departureAddress2: "", // 출발주소2
      destinationAddress2: "", // 도착주소2
      departureAddress3: "", // 출발주소3
      destinationAddress3: "", // 도착주소3
      departureZipCode1: "", // 출발주소1 우편번호
      destinationZipCode1: "", // 출발주소1 우편번호
      departureZipCode2: "", // 출발주소2 우편번호
      destinationZipCode2: "", // 출발주소2 우편번호
      departureZipCode3: "", // 출발주소3 우편번호
      destinationZipCode3: "", // 출발주소3 우편번호
      workCondition1: "", // 작업조건1
      workCondition2: "", // 작업조건2
    },
  },
  chargeList: [
    {
      id: 1,
      text: "1page",
      roomList: [
        {
          id: 1,
          name: "사무실",
          type: "office",
          quantity: 0,
          cbm: 0,
          itemList: [
            {
              id: 1,
              itemCode: "desk1",
              category: "책상",
              item: "접이식 책상",
              quantity: 0,
              cbm: 0,
              carryType: 0,
              isCustom: false,
            },
          ],
        },
      ],
      name: "", // 품명
      category: "", // 작업구분
      contents: "", // 작업내용
      unit: "", // 단위
      remark: "", // 비고
      total: "", // 5. 합계[1+2+3+4]
      expenses: "", // 6.공과잡비
      commonCost: "", // 7.일반관리비
      profit: "", // 8.이윤
      totalServiceCost: "", // 8.총 용역원가
      quotedPrice: "", // 9. 견적가
      expensesRate: "5", // 공과잡비비율
      commonCostRate: "10", // 일반관리비비율
      profitRate: "10", //이윤 비율
      materialCost: {
        title: "재료비",
        total: "",
        List: [
          {
            id: 0,
            name: "포장용 박스",
            spec: "450*430*400",
            unit: "장",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "에어캡",
            spec: "50cm*50m",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "포장용 테이프",
            spec: "50mm*50m",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "PC 박스",
            spec: "600*410*470",
            unit: "장",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "바구니",
            spec: "610*380*320",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 5,
            name: "청랩",
            spec: "50cm*500m",
            unit: "롤",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 6,
            name: "물품표",
            spec: "",
            unit: "개",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 7,
            name: "보양자재",
            spec: "",
            unit: "장",
            quantity: "0",
            unitPrice: "0",
            amount: "",
            remarks: "",
          },
          {
            id: 8,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 9,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
      movingCost: {
        title: "차량비",
        total: "",
        List: [
          {
            id: 0,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
      laborCost: {
        title: "노무비",
        total: "",
        List: [
          {
            id: 0,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
      ectCost: {
        title: "기타",
        total: "",
        List: [
          {
            id: 0,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 1,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 2,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 3,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
          {
            id: 4,
            name: "",
            spec: "",
            unit: "",
            quantity: "",
            unitPrice: "",
            amount: "",
            remarks: "",
          },
        ],
      },
    },
  ],
};

export const roomDataList = [
  {
    id: 1,
    type: 1,
    typeName: "office",
    name: "사무실",
  },
  {
    id: 2,
    type: 2,
    typeName: "meetingRoom",
    name: "회의실",
  },
  {
    id: 3,
    type: 3,
    typeName: "executiveRoom",
    name: "임원실",
  },
  {
    id: 4,
    type: 4,
    typeName: "documentStorage",
    name: "문서고",
  },
  {
    id: 5,
    type: 5,
    typeName: "storage",
    name: "창고",
  },
  {
    id: 6,
    type: 6,
    typeName: "pantry",
    name: "탕비실",
  },
  {
    id: 7,
    type: 7,
    typeName: "serverRoom",
    name: "전산실",
  },
  {
    id: 8,
    type: 8,
    typeName: "custom",
    name: "기타",
  },
];

export const categoryList = [
  {
    categoryType: 1,
    category: "desk",
    categoryName: "책상",
    itemList: [
      {
        type: 1,
        typeName: "desk1",
        itemName: "접이식 책상",
        cbm: 0.25,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "desk2",
        itemName: "ㅡ형 책상 세트",
        cbm: 0.8,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "desk3",
        itemName: "L형 책상 세트",
        cbm: 1.33,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "desk4",
        itemName: "회의용 테이블",
        cbm: 0.97,
        isCustom: false,
      },
      {
        type: 5,
        typeName: "desk5",
        itemName: "PC + 모니터(듀얼 포함)",
        cbm: 0.17,
      },
      {
        type: 6,
        typeName: "desk0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 2,
    category: "chair",
    categoryName: "의자류",
    itemList: [
      {
        type: 1,
        typeName: "chair1",
        itemName: "개인 의자",
        cbm: 0.25,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "chair2",
        itemName: "회의용 의자(소)",
        cbm: 0.97,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "chair3",
        itemName: "회의용 의자(접이식)",
        cbm: 0.1,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "chair4",
        itemName: "안마의자",
        cbm: 1.35,
        isCustom: false,
      },
      {
        type: 5,
        typeName: "chair0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 3,
    category: "box",
    categoryName: "박스/파티션",
    itemList: [
      {
        type: 1,
        typeName: "box1",
        itemName: "개인 물품(소)",
        cbm: 0.08,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "box2",
        itemName: "일반파티션",
        cbm: 0.11,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "box3",
        itemName: "블록파티션",
        cbm: 0.13,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "box0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 4,
    category: "wardrobe",
    categoryName: "옷장",
    itemList: [
      {
        type: 1,
        typeName: "wardrobe1",
        itemName: "1칸 옷장",
        cbm: 0.37,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "wardrobe2",
        itemName: "2칸 옷장",
        cbm: 0.67,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "wardrobe0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 5,
    category: "sharedStorage",
    categoryName: "공용장",
    itemList: [
      {
        type: 1,
        typeName: "sharedStorage1",
        itemName: "3단 공용장",
        cbm: 0.5,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "sharedStorage2",
        itemName: "4단 공용장",
        cbm: 0.5,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "sharedStorage3",
        itemName: "5단 공용장",
        cbm: 0.67,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "sharedStorage4",
        itemName: "6단 공용장",
        cbm: 0.67,
        isCustom: false,
      },
      {
        type: 5,
        typeName: "sharedStorage0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 6,
    category: "sofa",
    categoryName: "소파",
    itemList: [
      {
        type: 1,
        typeName: "sofa1",
        itemName: "1인용",
        cbm: 0.48,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "sofa2",
        itemName: "2인용",
        cbm: 1.3,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "sofa3",
        itemName: "3인용",
        cbm: 2.27,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "sofa0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 7,
    category: "cabinet",
    categoryName: "캐비닛, 랙",
    itemList: [
      {
        type: 1,
        typeName: "cabinet1",
        itemName: "캐비닛, 경량랙, 중량랙",
        cbm: 1.1,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "cabinet2",
        itemName: "모빌랙",
        cbm: 1.0,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "cabinet0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 8,
    category: "safe",
    categoryName: "금고",
    itemList: [
      {
        type: 1,
        typeName: "safe1",
        itemName: "소형",
        cbm: 0.23,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "safe2",
        itemName: "중형",
        cbm: 0.6,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "safe3",
        itemName: "대형",
        cbm: 0.98,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "safe0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 9,
    category: "refrigerator",
    categoryName: "냉장고",
    itemList: [
      {
        type: 1,
        typeName: "refrigerator1",
        itemName: "소형",
        cbm: 0.37,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "refrigerator2",
        itemName: "대형",
        cbm: 0.76,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "refrigerator3",
        itemName: "초대형(연구실형)",
        cbm: 2.0,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "refrigerator0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
  {
    categoryType: 10,
    category: "others",
    categoryName: "기타",
    itemList: [
      {
        type: 1,
        typeName: "others1",
        itemName: "TV(80인치 이하)",
        cbm: 0.78,
        isCustom: false,
      },
      {
        type: 2,
        typeName: "others2",
        itemName: "공기청정기",
        cbm: 0.39,
        isCustom: false,
      },
      {
        type: 3,
        typeName: "others3",
        itemName: "문서세단기",
        cbm: 0.2,
        isCustom: false,
      },
      {
        type: 4,
        typeName: "others4",
        itemName: "복합기",
        cbm: 0.29,
        isCustom: false,
      },
      {
        type: 5,
        typeName: "others5",
        itemName: "정수기",
        cbm: 0.7,
        isCustom: false,
      },
      {
        type: 6,
        typeName: "others6",
        itemName: "전자레인지",
        cbm: 0.04,
        isCustom: false,
      },
      {
        type: 7,
        typeName: "others7",
        itemName: "전자칠판(화이트보드)",
        cbm: 0.03,
        isCustom: false,
      },
      {
        type: 8,
        typeName: "others0",
        itemName: "사용자정의",
        cbm: 0,
        isCustom: true,
      },
    ],
  },
];

export const carryType = [
  { status: "운반", statusCode: 0 },
  { status: "폐기", statusCode: 1 },
  { status: "하역", statusCode: 2 },
  { status: "경유", statusCode: 3 },
  { status: "방치", statusCode: 4 },
  { status: "업체", statusCode: 5 },
];

export function formatDate(dateString: string) {
  if (dateString.length !== 8) {
    return dateString;
  }

  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6);

  return `${year}.${month}.${day}`;
}
